import { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  HiOutlineXMark,
  HiOutlineCheck,
  HiOutlineUser,
  HiOutlineFolder,
} from "react-icons/hi2";

import {
  updateDossier,
  getDossiers,
} from "../../redux/features/dossiers/dossierSlice";

import { getUsers } from "../../redux/features/users/userSlice";

import "./DossierEditModal.css";

const STATUS_OPTIONS = [
  {
    value: "active",
    label: "Actief",
  },

  {
    value: "paused",
    label: "Gepauzeerd",
  },

  {
    value: "completed",
    label: "Afgerond",
  },

  {
    value: "cancelled",
    label: "Stopgezet",
  },
];

const STEP_OPTIONS = [
  {
    value: "aanmelding",
    label: "Aanmelding",
  },

  {
    value: "administratie",
    label: "Administratie",
  },

  {
    value: "begeleiding",
    label: "Begeleiding",
  },

  {
    value: "vdab",
    label: "VDAB",
  },

  {
    value: "kld",
    label: "KLD",
  },

  {
    value: "afronding",
    label: "Afronding",
  },
];

export default function DossierEditModal({ isOpen, onClose, dossier }) {
  const dispatch = useDispatch();

  const { isUpdating } = useSelector((state) => state.dossiers);

  const { users } = useSelector((state) => state.users);

  const [formData, setFormData] = useState({
    coach: "",
    status: "",
    current_step: "",
  });

  const [error, setError] = useState("");

  const coaches = useMemo(() => {
    return users.filter((user) =>
      ["POWER_INTERNAL_COACH", "POWER_EXTERNAL_COACH"].includes(user.role),
    );
  }, [users]);

  useEffect(() => {
    if (!isOpen) return;

    dispatch(
      getUsers({
        limit: 100,
      }),
    );
  }, [dispatch, isOpen]);

  useEffect(() => {
    if (!dossier) return;

    setFormData({
      coach: dossier?.coach?._id || "",

      status: dossier?.status || "active",

      current_step: dossier?.current_step || "aanmelding",
    });
  }, [dossier]);

  if (!isOpen || !dossier) {
    return null;
  }

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,

      [name]: value,
    }));

    setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await dispatch(
        updateDossier({
          id: dossier._id,

          data: {
            coach: formData.coach || null,

            status: formData.status,

            current_step: formData.current_step,
          },
        }),
      ).unwrap();

      await dispatch(
        getDossiers({
          page: 1,
          limit: 12,
        }),
      );

      onClose();
    } catch (error) {
      setError(error?.message || "Er ging iets mis bij het opslaan.");
    }
  };

  return (
    <div className="dossier-edit-modal">
      <div className="dossier-edit-modal__backdrop" onClick={onClose} />

      <div className="dossier-edit-modal__content">
        <div className="dossier-edit-modal__header">
          <div>
            <span>Dossier wijzigen</span>

            <h2>{dossier?.client?.display_name || "Onbekende cliënt"}</h2>
          </div>

          <button
            type="button"
            className="dossier-edit-modal__close"
            onClick={onClose}
          >
            <HiOutlineXMark />
          </button>
        </div>

        {error && <div className="dossier-edit-modal__error">{error}</div>}

        <form className="dossier-edit-modal__form" onSubmit={handleSubmit}>
          <div className="dossier-edit-modal__group">
            <label>
              <HiOutlineUser />

              <span>Coach</span>
            </label>

            <select name="coach" value={formData.coach} onChange={handleChange}>
              <option value="">Geen coach geselecteerd</option>

              {coaches.map((coach) => (
                <option key={coach._id} value={coach._id}>
                  {coach.first_name} {coach.last_name}
                </option>
              ))}
            </select>
          </div>

          <div className="dossier-edit-modal__group">
            <label>
              <HiOutlineFolder />

              <span>Status</span>
            </label>

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              {STATUS_OPTIONS.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select>
          </div>

          <div className="dossier-edit-modal__group">
            <label>
              <HiOutlineFolder />

              <span>Stap</span>
            </label>

            <select
              name="current_step"
              value={formData.current_step}
              onChange={handleChange}
            >
              {STEP_OPTIONS.map((step) => (
                <option key={step.value} value={step.value}>
                  {step.label}
                </option>
              ))}
            </select>
          </div>

          <div className="dossier-edit-modal__actions">
            <button
              type="button"
              className="dossier-edit-modal__cancel"
              onClick={onClose}
              disabled={isUpdating}
            >
              Annuleren
            </button>

            <button
              type="submit"
              className="dossier-edit-modal__submit"
              disabled={isUpdating}
            >
              <HiOutlineCheck />

              <span>{isUpdating ? "Opslaan..." : "Opslaan"}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
